<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4>Sub Category Master
            <!-- <a data-toggle="collapse" data-target="#collapseSubCategory" class="collapsed"
                                       style="font-size: 14px;cursor: pointer;">
                                        <b>Sub Category Master</b>
                                        <span class="pull-right" style="font-style: oblique;font-size: 12px">
                                            <i class="glyphicon glyphicon-search"></i>
                                        </span>
                                    </a> -->
              </h4>
          </div>
          <div id="collapse-example" class="collapse show" aria-labelledby="heading-example">
          <div class="card-body">
            <form [formGroup]="SubCategoryForm">
              <div class="cardSearch2">
              <div class="card-header2 form-control2" data-toggle="collapse" href="#collapseExample" (click)="showhideAdd()"  role="button"
              aria-expanded="false" aria-controls="collapseExample">
              <header class="panel-heading">
                  <h5 class="panel-title">Add Sub Category(Tap to Expand)</h5>
              </header>
          </div>
          <div *ngIf="IsAddpanelshow" id="collapseExample">
            <div class="card-body2">
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 required"> <label>Category</label></div>
                    <div class="col-md-8">
                      <div class="col-md-8">
                        <p-dropdown [options]="categoryList" placeholder="--Select--" formControlName="SelectedCategory"
                          filter="true" [showClear]="true" optionLabel="label">
                        </p-dropdown>
                        <mat-error
                        *ngIf="GetFormControls('SelectedCategory').invalid && (GetFormControls('SelectedCategory').dirty || GetFormControls('SelectedCategory').touched)"
                        class="ValidationError">
                        <mat-error *ngIf="GetFormControls('SelectedCategory').errors.required">
                          Category Name is required.
                        </mat-error>
                      </mat-error>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 required"> <label>Sub Category Name</label></div>
                    <div class="col-md-8">
                      <input class="form-control" maxlength="50"
                       formControlName="SubCategoryName">
                       <mat-error
                       *ngIf="GetFormControls('SubCategoryName').invalid && (GetFormControls('SubCategoryName').dirty || GetFormControls('SubCategoryName').touched)"
                       class="ValidationError">
                       <mat-error *ngIf="GetFormControls('SubCategoryName').errors.required">
                        Sub Category Name is required.
                       </mat-error>
                     </mat-error>
                    </div>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
              <br>
              <div class="clearfix"></div>
              <div class="row" style="margin-top: -5px;margin-bottom: 10px;">
                <div class="col-md-4">
                  <div class="row">
                    <div class="col-md-4"> <label>Status</label></div>
                    <div class="col-md-8">
                      <div class="col-md-8">
                        <input type="checkbox" class="checkbox_size" formControlName="IsActive" />
                      </div>
                    </div>
                  </div>
                </div>
               
                 <div class="col-md-4">
                  
                       <button type="submit" class="btn-primary1" (click)="submitdata()">Submit</button>
                       
                         <button class="btn-primary1" (click)="Export()">Export as Excel</button>

                 </div>
                 <div class="col-md-4">
                   <!-- <button type="clear" class="btn-primary1" (click)="cleardata()">Clear</button> -->
                  
                 </div>
               
               </div>
            </div>
          </div>
              </div>
               <div class="clearfix"></div>

                <div class="cardSearch2">
                  <div class="card-header2 form-control2" data-toggle="collapse" href="#collapseSearch" (click)="showhide()" role="button"
                      aria-expanded="false" aria-controls="collapseSearch">
                      <header class="panel-heading">
                          <h5 class="panel-title">Search(Tap to Expand)</h5>
                      </header>
                  </div>
                  <div *ngIf="Ispanelshow" id="collapseSearch">
                      <div class="card-body2">
                          <div class="row">
                              <div class="form-group2 col-md-6">
                                  <label class="required">Category Name</label>
                              <p-dropdown [options]="categoryList" placeholder="--Select--" formControlName="CategorySearch"
                              filter="true" [showClear]="true" optionLabel="label">
                            </p-dropdown>
                              </div>
                              <div class="form-group2 col-md-6">
                                  <label class="required">Status</label>
                                  <p-dropdown [options]="statusList" optionLabel="StatusName" placeholder="--Select--" formControlName="StatusSearch"
                                  filter="true" [showClear]="true">
                                </p-dropdown>
                              </div>
                          </div>
                          
                          <div class="clearfix"></div>
                        <div class="row">
        
                          <div class="col-md-12" style="text-align: center;">
                            <button class="btn-primary1" (click)="Exit()">Exit</button>
                            <button class="btn-primary1" (click)="ResetData()">Reset</button>
                            <button type="submit" style="margin-top: 10px;margin-right: 80px;" value="Submit" class="btn-primary1" (click)="GetResult()" >Get Result</button>
                            
        
                          </div>
                          
                        </div>
                      </div>
                  </div>
              </div>
              <div class="clearfix"></div>

                <div class="row">
                  
                <div class="col-md-12">
                 
                  <div class="mat-elevation-z8 top-margin-border" #TABLE>
          <table mat-table [dataSource]="SubCategoryDataSource" style="width:100% !important">
  
            <ng-container matColumnDef="SubCategoryId" >
              <th mat-header-cell *matHeaderCellDef> SubCategory ID </th>
              <td mat-cell *matCellDef="let element" style="cursor:pointer;color:blue; text-decoration: underline;"> {{element.SubCategoryId}} </td>
            </ng-container>
                        
            <ng-container matColumnDef="SubCategoryName">
              <th mat-header-cell *matHeaderCellDef> SubCategory Name </th>
              <td mat-cell *matCellDef="let element"> {{element.SubCategoryName}} </td>
            </ng-container>
  
            <ng-container matColumnDef="CategoryName">
              <th mat-header-cell *matHeaderCellDef> Category Name </th>
              <td mat-cell *matCellDef="let element"> {{element.CategoryName}} </td>
            </ng-container>

            <ng-container matColumnDef="IsActive">
              <th mat-header-cell *matHeaderCellDef> IsActive </th>
              <td mat-cell *matCellDef="let element"> {{element.IsActive}} </td>
            </ng-container>

            <ng-container matColumnDef="Status">
              <th mat-header-cell *matHeaderCellDef> Status </th>
              <td mat-cell *matCellDef="let element"> {{element.Status}} </td>
            </ng-container>

            <ng-container matColumnDef="Edit">
              <th mat-header-cell *matHeaderCellDef> Action </th>
              <td mat-cell *matCellDef="let element;  let j = index;" style="cursor:pointer;color:blue; text-decoration: underline;" (click)="rowclickdata(element.SubCategoryId)"> Edit </td>
            </ng-container>
  
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <mat-paginator  #paginator
          [length]="_global.length"
          [pageIndex]="_global.pageIndex"
          [pageSize]="_global.RecordSize"
          [pageSizeOptions]="[5, 10, 25, 100]"
          (page)="onPaginateChange1($event)"></mat-paginator>
        </div>
              </div>
             
              
                </div>
            </form>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>